import { render, staticRenderFns } from "./RepresentativeOrder.vue?vue&type=template&id=48dedbfd&scoped=true&"
import script from "./RepresentativeOrder.vue?vue&type=script&lang=js&"
export * from "./RepresentativeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dedbfd",
  null
  
)

export default component.exports